module.exports = __webpack_public_path__ + "media/src/assets/Images/InstagramPng-141ebc4af0851f03eaaa047f955de1e2.png";